import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  FocusEvent,
} from 'react';
import { pick } from 'lodash';

import { useSelector, useDispatch } from '../../store/utils';
import { variablesChange } from '../../store/actions';
import { VariableId, Variables } from '../../store/types';

type Props = {
  variableIds?: VariableId[];
};

export const Inspect = ({ variableIds }: Props) => {
  const { connected, variables: store } = useSelector((s) => s);
  const dispatch = useDispatch();

  const [beforeEditing, setBeforeEditing] = useState<Record<string, any>>();
  const [invalid, setInvalid] = useState(false);
  const textarea = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (!textarea.current) return;

    const focused = textarea.current.matches(':focus');
    if (focused) return;

    const storeForInspect = variableIds ? pick(store, ...variableIds) : store;

    textarea.current.value = JSON.stringify(storeForInspect, null, 2);
  }, [store]);

  const onBlur = useCallback(
    (e: FocusEvent<HTMLTextAreaElement>) => {
      setInvalid(false);
      let newVal: Record<string, any> | undefined;
      try {
        newVal = JSON.parse(e.target.value);
      } catch (err) {
        setInvalid(true);
        return;
      }

      if (!newVal || !beforeEditing) return;

      const diff = Object.entries(newVal).reduce<Record<string, any>>(
        (acc, [key, value]) => {
          if (JSON.stringify(value) === JSON.stringify(beforeEditing[key])) {
            return acc;
          }
          return { ...acc, [key]: value };
        },
        {}
      );

      setBeforeEditing(undefined);

      dispatch(variablesChange(diff as Partial<Variables>));
    },
    [beforeEditing]
  );

  if (!connected) return null;

  return (
    <textarea
      ref={textarea}
      onFocus={(e) => setBeforeEditing(JSON.parse(e.target.value))}
      onBlur={onBlur}
      style={{
        width: 800,
        height: 800,
        resize: 'none',
        border: invalid ? 'solid 2px red' : '',
      }}
    />
  );
};
